import { transformRoutes } from '@backoffice-frontend/common'

const BaseLegalDocumentManagementAreaRoutes = {
  route: '/legal-document-management',
}

export const LegalDocumentManagementAreaRoutes = transformRoutes(
  BaseLegalDocumentManagementAreaRoutes,
)
